var React = require('react');

function CrossCart (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.0269 13.8933L0.893555 26.0267L1.76021 26.8933L13.8936 14.7599L26.027 26.8934L26.8937 26.0267L14.7603 13.8933L26.8933 1.76021L26.0267 0.893555L13.8936 13.0266L1.76059 0.893607L0.893934 1.76027L13.0269 13.8933Z","fill":"#245437"}));
}

CrossCart.defaultProps = {"width":"27","height":"27","viewBox":"0 0 27 27","fill":"none"};

module.exports = CrossCart;

CrossCart.default = CrossCart;
